import { KIND, SIZE } from 'baseui/button'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'baseui/modal'
import useCreditCheck from './useCreditCheck'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'

const CreditCheck = () => {
  const {
    t,
    isLoading,
    result,
    error,
    creditCheckHandler,
    isVisible,
    canRunCheck,
    isModalOpen,
    closeModal,
  } = useCreditCheck()

  if (!isVisible) {
    return null
  }

  return (
    <div style={{ width: '100%' }}>
      <SDButton
        block
        kind={KIND.secondary}
        size={SIZE.compact}
        startEnhancer={() => <IconCarbonCheckmarkOutline size={24} />}
        onClick={creditCheckHandler}
        isLoading={isLoading}
        disabled={!canRunCheck || isLoading}
      >
        {t('subscriptionForm:credit_check.button')}
      </SDButton>
      <Modal
        onClose={closeModal}
        isOpen={isModalOpen}
        overrides={{
          Dialog: {
            style: {
              width: '40vw',
              display: 'flex',
              flexDirection: 'column'
            }
          }
        }}
      >
        <ModalHeader>{t('subscriptionForm:credit_check.button')}</ModalHeader>
        <ModalBody>
          {result && (
            <Notification
              kind={result.approved ? NOTIFICATION_KIND.positive : NOTIFICATION_KIND.negative}
              overrides={{
                Body: {
                  style: {
                    width: '100%',
                    borderRadius: '10px',
                    margin: '0px'
                  }
                }
              }}
            >
              {result.approved ? t('subscriptionForm:credit_check.approved') : t('subscriptionForm:credit_check.rejected')}
              {result.message && ` - ${result.message}`}
            </Notification>
          )}
          {error && (
            <Notification
              kind={NOTIFICATION_KIND.negative}
              overrides={{
                Body: {
                  style: {
                    width: '100%',
                    borderRadius: '10px',
                    margin: '0px'
                  }
                }
              }}
            >
              {error}
            </Notification>
          )}
        </ModalBody>
        <ModalFooter>
          <SDButton kind={KIND.secondary} size={SIZE.compact} onClick={closeModal}>
            {t('common:close')}
          </SDButton>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default CreditCheck
